import { Component, ViewEncapsulation, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';

@Component({
	selector: 'highlights-modal',
	templateUrl: './highlights-modal.component.html',
	styleUrls: ['./highlights-modal.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class HighlightsModalComponent {

	@Input() year: any;
	@Input() section: string;
	@Input() showDescription: boolean;
	@Input() isVisible: boolean = false;
	@Output() onVisibleChange = new EventEmitter<boolean>();

	imageNum: number;
	slideIndex = 1;

	constructor() {}

	array(n: number): number[] {
		return [...Array(n).keys()];
	}

	closeModal() {
		document.body.removeAttribute('style');
		this.isVisible = false;
		this.onVisibleChange.emit(this.isVisible);
	}

	plusSlides(n){
		this.showSlides(this.slideIndex += n);
	}

	currentSlide(n) {
		this.showSlides(this.slideIndex = n);
	}

	showSlides(n) {
		var i;
		var slides = document.getElementsByClassName("highlights-image");
		var image = document.getElementsByClassName("demo");
		if (n > slides.length) this.slideIndex = 1;
		if (n < 1) this.slideIndex = slides.length;
		for (i = 0; i < slides.length; i++) {
			var img = slides[i];
			if (img.classList.contains("d-block")) img.classList.remove("d-block");
			slides[i].classList.add("d-none");
		}
		for (i = 0; i < image.length; i++) {
			if (image[i].classList.contains("active")) image[i].classList.remove("active");
		}
		var slide = slides[this.slideIndex - 1];
		if (slide.classList.contains("d-none")) slide.classList.remove("d-none");
		slide.classList.add("d-block");
		image[this.slideIndex - 1].classList.add("active");
	}
	
	ngOnDestroy(){
		this.closeModal();
	}

	ngOnChanges(changes: SimpleChanges) {
		switch (this.year) {
			case 2020:
				this.imageNum = 38;
				break;
			case 2021:
				this.imageNum = 17;
				break;
			case 2022:
				this.imageNum = 30;
				break;
			case 2023:
				if (this.section == 'event') {
					this.imageNum = 34;
				} else if (this.section == 'individual') {
					this.imageNum = 14;
				}  else if (this.section == 'corporate') {
					this.imageNum = 14;
				}
				break;
		}
	}

	ngOnInit() {}
}